// extracted by mini-css-extract-plugin
export default {"quiz_header":"Fu","quiz_header_wrapper":"Gu","header_button":"Hu","hidden":"Iu","gainful_logo":"Ju","MyClassEnterDone":"Ku","x_button":"Lu","logoWrapper":"Mu","logoWrapperMob":"Nu"};
    if(module.hot) {
      // 1714442369037
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  